import { useCallback } from 'react';
import { useHboActivationContext } from '../context/HboActivationContext';
import { isHboContentInfo } from '../utils/isHboContent';

// Intercepta CUALQUIER navegacion (a vcard, nodo o canal en vivo) originada por un click
// en contenido de HBO, evaluada en el propio event handler de navegacion y no como un tipo
// de contenido especial: delega en requestActivation, que dispara una consulta de estado
// fresca en cada seleccion (ver TBRFRE-1790 7.2.1, WEBCL-3778). Si el contenido no es de
// HBO o no hay Provider disponible, navega de inmediato.
export const useHboNavigationInterceptor = () => {
  const hboActivation = useHboActivationContext();

  return useCallback(
    (contentInfo, onNavigate) => {
      if (isHboContentInfo(contentInfo) && hboActivation?.requestActivation) {
        hboActivation.requestActivation(onNavigate);
        return;
      }

      onNavigate();
    },
    [hboActivation],
  );
};
